import { createStyles } from "@mantine/emotion";

export default createStyles ( theme => ( {
	container: {
		display      : "flex",
		marginBottom : "1rem",
		marginTop    : "0.5rem",
		gap          : "2rem"
	}
} ) );

